import { useState, useEffect } from 'react';
import { api } from '../lib/api.ts';
import { ChartRenderer } from '../components/ChartRenderer.tsx';
import { ScoreBadge } from '../components/ScoreBadge.tsx';
import type { Item, ChartSpec } from '../lib/types.ts';

export function ChartLab() {
  const [items, setItems] = useState<Item[]>([]);
  const [selected, setSelected] = useState<Item | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.items.list({ status: 'analysed', score_min: 6, limit: 50 }).then(res => {
      const chartItems = res.items.filter(i => i.deep_final_classification === 'CHART' && i.deep_chart_spec?.viable);
      setItems(chartItems);
      if (chartItems.length > 0) setSelected(chartItems[0]!);
    }).finally(() => setLoading(false));
  }, []);

  if (loading) return <p style={{ color: '#999' }}>Loading charts…</p>;

  return (
    <div>
      <h1 style={{ margin: '0 0 20px', fontSize: 20 }}>Chart Lab</h1>

      {items.length === 0 && (
        <p style={{ color: '#999', fontStyle: 'italic' }}>No chart items available yet.</p>
      )}

      <div style={{ display: 'flex', gap: 24 }}>
        {/* Sidebar */}
        <div style={{ width: 280, flexShrink: 0 }}>
          {items.map(item => (
            <div key={item.id}
              onClick={() => setSelected(item)}
              style={{
                padding: '10px 14px',
                borderRadius: 6,
                cursor: 'pointer',
                background: selected?.id === item.id ? '#f0f4ff' : 'transparent',
                borderLeft: selected?.id === item.id ? '3px solid #1a6aff' : '3px solid transparent',
                marginBottom: 4,
              }}>
              <div style={{ display: 'flex', gap: 6, marginBottom: 4 }}>
                <ScoreBadge score={item.deep_final_score} />
                <span style={{ fontSize: 10, color: '#999' }}>{item.source_id.replace(/_/g, ' ')}</span>
              </div>
              <p style={{ margin: 0, fontSize: 13, fontWeight: 600, color: '#111', lineHeight: 1.3 }}>
                {item.deep_chart_spec?.title ?? item.title ?? '—'}
              </p>
            </div>
          ))}
        </div>

        {/* Chart panel */}
        {selected && (
          <div style={{ flex: 1 }}>
            <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 6, padding: 24 }}>
              <div style={{ marginBottom: 16 }}>
                <ScoreBadge score={selected.deep_final_score} />
                <span style={{ fontSize: 11, color: '#999', marginLeft: 8 }}>{selected.source_id.replace(/_/g, ' ')}</span>
              </div>
              <h2 style={{ margin: '0 0 16px', fontSize: 18 }}>
                {selected.deep_chart_spec?.title ?? selected.title}
              </h2>
              <ChartRenderer spec={selected.deep_chart_spec as ChartSpec} height={350} />
              {selected.deep_summary && (
                <p style={{ marginTop: 20, fontSize: 14, color: '#444', lineHeight: 1.6 }}>{selected.deep_summary}</p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
